module.exports = (__parcel__import__("cSPoc")).then(() => parcelRequire('4MKVl'));